import Vue from 'vue'

export default function gtmPlugin(store) {
  store.dataLayerPush = ({
    user,
    event,
    payload,
    eventType,
  }) => {
    try {
      Vue.gtm.trackEvent({
        event,
        noninteraction: eventType,
        payload,
        eventType,
        user,
      })
    } catch (err) {
      throw new Error(`Error with gtm.trackEvent: ${err}`)
    }
  }
}
